import { types, Instance } from 'mobx-state-tree';
const { model, string, identifierNumber, maybeNull, number, boolean } = types;

const UserModel = model('UserModel', {
  id: identifierNumber,
  firstName: maybeNull(string),
  middleName: maybeNull(string),
  secondName: maybeNull(string),
  email: string,
  passwordSet: maybeNull(boolean),
}).views((self) => ({
  get name() {
    const parts = [self.firstName, self.middleName, self.secondName].filter(Boolean);
    return parts.join(' ') || 'Unknown User';
  },
}));

export const LogModel = model('LogModel', {
  id: identifierNumber,
  client_id: maybeNull(number),
  user_id: number,
  login_time: string,
  ip_address: string,
  city: maybeNull(string),
  region: maybeNull(string),
  country: maybeNull(string),
  device: maybeNull(string),
  os: maybeNull(string),
  browser: maybeNull(string),
  created_at: string,
  updated_at: string,
  user: maybeNull(UserModel),
  // Legacy fields for compatibility
  additionalData: maybeNull(string),
  eventType: maybeNull(string),
  clientId: maybeNull(number),
});

export type ILogModel = Instance<typeof LogModel>;

export const LogsInfoModel = model('LogsInfoModel', {
  name: maybeNull(string),
  lastName: maybeNull(string),
  id: maybeNull(number),
  email: maybeNull(string),
  organizationName: maybeNull(string),
  organizationDomain: maybeNull(string),
  organizationFullDomain: maybeNull(string),
  eduNonProfitGovOrganization: maybeNull(boolean),
  salesTaxGstVatExemptOrganization: maybeNull(boolean),
  password: maybeNull(string),
  imageUrl: maybeNull(string),
});

export type ILogsInfoModel = Instance<typeof LogsInfoModel>;
